import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { cleanCartData, getRoleFromStorage } from '../../helpers/userData'
import { getTranslate, lang } from '../../localization'
import { ROLE } from '../../staticRoleManagement/types'
import { ConfirmPrimitiveReservation, PageStepper } from '../../types/cart'
import BookerDetailsSummary from './components/BookerDetailsSummary'
import GuestDetailsSummary from './components/GuestDetailsSummary'
import PriceDetails from './components/PriceDetails'
import SelectedRoomList from './components/SelectedRoomList'

type StepThreeProps = {
  confirmPrimitiveData: ConfirmPrimitiveReservation | undefined
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  setRedirectLink: React.Dispatch<React.SetStateAction<string>>
  setRedirectTitle: React.Dispatch<React.SetStateAction<string>>
  isTimeExpired: boolean
}
const StepThree = ({
  confirmPrimitiveData,
  isTimeExpired,
  setRedirectLink,
  setShowModal,
  setRedirectTitle
}: StepThreeProps) => {
  const params = useParams<{
    channelId: string
    code: string
    name: string
    page: PageStepper
    reservationNumber?: string
  }>()
  const isRoleAdmin = getRoleFromStorage() === ROLE.ADMIN
  useEffect(() => {
    if (!isRoleAdmin) {
      localStorage.removeItem('confirmPrimitiveInput')
    }
  }, [])

  useEffect(() => {
    if (isTimeExpired) {
      if (params.page === 'payment' && params.reservationNumber) {
        setRedirectTitle(
          getTranslate(
            'Your time has been expired. You will be redirect to modify page'
          )
        )
        setRedirectLink(
          `/${lang}/booking/list/${params.reservationNumber}/edit`
        )
      } else {
        setRedirectTitle(
          getTranslate(
            'Your time has been expired. You will be redirect to booking page'
          )
        )
        setRedirectLink(
          `/${lang}/book/${params.channelId}/${params.code}/${params.name}`
        )
      }
      setShowModal(true)
      cleanCartData()
      localStorage.removeItem('confirmPrimitiveInput')
      localStorage.removeItem('confirmPrimitiveOutput')
      localStorage.removeItem('hotelDetails')
      localStorage.removeItem('primitiveData')
    }
  }, [isTimeExpired])

  return confirmPrimitiveData?.reservationInfo.detailedRoomStays.length ? (
    <>
      <SelectedRoomList
        items={confirmPrimitiveData?.reservationInfo.selectedRooms}
      />
      <BookerDetailsSummary
        booker={confirmPrimitiveData?.reservationInfo.booker}
      />
      <GuestDetailsSummary
        detailedRoomStays={
          confirmPrimitiveData?.reservationInfo.detailedRoomStays
        }
      />
      <PriceDetails
        detailedRoomStays={
          confirmPrimitiveData?.reservationInfo.detailedRoomStays
        }
        curruncy={confirmPrimitiveData?.paymentInfo.currency}
      />
    </>
  ) : (
    <></>
  )
}

export default StepThree
